var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner_code"},[_vm._v("Partner Code: "+_vm._s(_vm.customer_name))])}
var staticRenderFns = []

export { render, staticRenderFns }